app.service("UserService", [
	"$http",
	"ENV",
	"Session",
	"$base64",
	"$q",
	function ($http, ENV, Session, $base64, $q) {
		var service = {
			isProcessing: false,

			getUser: function () {
				let headers =  {
					Authorization: "Bearer " + Session.token
				};
				if(Session.practice && Session.practice.id){
                     headers =  {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					};
				}
				return $http({
					method: "GET",
					url: ENV.API + "/api/users/" + Session.userId,
					headers
				});
			},

			getUserPractices: function () {
				return $http({
					method: "GET",
					url: ENV.API + "/api/users/" + Session.userId + "/practices",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			setPassword: function (password,oldPassword,username) {
				var authString = 'Bearer ' + Session.token;
				return $http({
					method: "POST",
					url: ENV.API + "/api/security/updatePassword",
					headers: {'Authorization': authString, },
					data: {
						newPassword: password,
						currentPassword: oldPassword
					},
				});
			},

			// getDoctors: function () {
			// 	return $http({
			// 		method: "GET",
			// 		url: ENV.API + "/api/users/oph",
			// 		headers: {
			// 			Authorization: "Bearer " + Session.token,
			// 		},
			// 	});
			// },

			getDoctorsByPracticeId: function (practiceId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/users/oph?practiceId="+practiceId,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},
			getOphByReferralType: function(referralType){
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/oph?referralType=${referralType}`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},
			getGeneralOpt: function(){
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/optometrists`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},
			getOptByReferralType: function(referralType){
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/optometrists?referralType=${referralType}`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},
			getRecentPatients: function () {
				if (!Session.practice || !Session.practice.id) {
					return $q.resolve({ data: [] });
				}
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/${Session.userId}/features/recent_patients`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			getUsersForLabel: function () {
				return $http({
					method: "GET",
					url: ENV.API + '/api/users/print-label-users',
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			getEthnicityCode: function () {
				return $http({
					method: "GET",
					url: ENV.API + '/api/ethnicity/level?level=4',
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			updateNonAdminUserFeatures: function (data) {
				return $http({
					method: "PUT",
					url: ENV.API + `/api/users/${Session.userId}/features`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data
				});
			},
			updateUserSettings: function (user) {
				service.isProcessing = true;
				return $http({
					method: "PATCH",
					url: ENV.API + `/api/users/${Session.userId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					data: user,
				});
			},
			updateReferralTypes: function (data){
				return $http({
					method: "PUT",
					url: ENV.API + `/api/users/${Session.userId}/features/referral-types`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data
				});
			},
			searchUsers: function (searchTerm) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/users/search?searchTerm=${encodeURIComponent(searchTerm)}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
		};

		return service;
	},
]);
